import { ACTIVE_TAB, ActiveTab } from '../pages/HEDashboard';
import { CANCEL_LAB_TEST_BOOKING, CANCEL_MEDICINES_ORDER } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
}

export default (
    docid: string,
    type: ActiveTab,
    orderId: string = '',
    cancelReason: string = '',
    remark: string = '',
): Promise<Response> => {
    if (type !== ACTIVE_TAB.MEDS && type !== ACTIVE_TAB.LABS) {
        return Promise.reject(new Error('Invalid order type'));
    }
    return fetchWithRefresh(
        type === ACTIVE_TAB.MEDS ? CANCEL_MEDICINES_ORDER(docid) : CANCEL_LAB_TEST_BOOKING(docid),
        {
            method: 'POST',
            body: JSON.stringify({
                order_id: orderId,
                cancel_reason: cancelReason,
                remark: remark,
            }),
            headers: {
                'Content-type': 'application/json',
            },
        },
    ).then((res) => res.json());
};
